import { cn } from "@/lib/utils";
import React from "react";

const InfoCard = ({
    icon: Icon,
    label,
    value,
    className,
    infoClassName,
    totalData,
    currentIndex
}) => {
    return (
        <div
            className={cn(
                "flex items-start gap-4 border-border-primary/80 pb-4",
                currentIndex < totalData - 2 && "border-b",
                className
            )}
        >
            {/* Icon container */}
            <div className="rounded-xl border border-border-primary/80 bg-background-icon/20 p-3">
                <Icon size={20} className="text-text-primary/80" />
            </div>

            {/* Text content */}
            <div className={cn("flex-1", infoClassName)}>
                {/* Label */}
                <p className="text-sm text-text-primary">
                    {label}
                </p>

                {/* Value */}
                <p className="mt-1 text-base font-medium text-text-secondary break-all whitespace-normal">
                    {value}
                </p>
            </div>
        </div>
    );
};

export default InfoCard;